import { useAppDispatch } from "../../../app/hooks";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { useEffect } from "react";
import { MassiveMessage } from "../../../redux/conversation/massive/massiveMessageSlice";
import { Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Stack, Chip, Typography, Box } from "@mui/material";
import PrizaContainer from "../../../features/base/grid/PrizaContainer";
import { massiveMessageUserSlice, retrieveMassiveMessageUsers, selectMassiveMessageUser } from "../../../redux/conversation/massive/massiveMessageUserSlice";
import { messageDismissedSlice, retrieveMessageDismissed, selectMessageDismissed } from "../../../redux/conversation/massive/messageDismissed";
import { worstState } from "../../../redux/common";
import MassiveMessageDetailRow from "./MassiveMessageDetailRow";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../../redux/object/objectCacheSlice";
import { getObjectTargetName, ObjectTarget } from "../../../app/permissions";
import { getMessagePriorityColor, getMessagePriorityName } from "../../../redux/conversation/messagePriority";
import { datetimeSimplifier } from "../../../redux/conversation/conversationSlice";
import { pureMessageSlice, retrievePureMessage, selectPureMessage } from "../../../redux/conversation/massive/pureMessageSlice";

interface MassiveMessageProps {
    selected: MassiveMessage;
    onClose: () => void;
}

const MassiveMessageDetail = (props: MassiveMessageProps) => {
    const dispatch = useAppDispatch();
    // const navigate = useNavigate();
    const user = useSelector(selectUser);
    // const massiveMessage = useSelector(selectMassiveMessage);
    const massiveMessageUser = useSelector(selectMassiveMessageUser);
    const messageDismissed = useSelector(selectMessageDismissed);
    const pureMessage = useSelector(selectPureMessage);
    const cache = useSelector(selectObjectCache);

    const target = getOrRetrieveNamedObject(dispatch, cache, props.selected.target, `${props.selected.targetId}`);
    const sender = getOrRetrieveNamedObject(dispatch, cache, ObjectTarget.USER, `${props.selected.userId}`);

    useEffect(() => {
        if (massiveMessageUser.request?.massiveMessageId && massiveMessageUser.request?.massiveMessageId != props.selected.id) {
            dispatch(massiveMessageUserSlice.actions.clean());
        }
        dispatch(retrieveMassiveMessageUsers({ massiveMessageId: props.selected.id }) );
    }, [massiveMessageUser, props.selected, user]);

    useEffect(() => {
        if (messageDismissed.request?.messageId && messageDismissed.request?.messageId != props.selected.id) {
            dispatch(messageDismissedSlice.actions.clean());
        }
        dispatch(retrieveMessageDismissed({ messageId: props.selected.id }) );
    }, [messageDismissed, props.selected, user]);

    useEffect(() => {
        if (pureMessage.request?.messageId && pureMessage.request?.messageId != props.selected.id) {
            dispatch(pureMessageSlice.actions.clean());
        }
        dispatch(retrievePureMessage({ messageId: props.selected.id }) );
    }, [pureMessage, props.selected, user]);

    const content = () => (
        <Stack spacing={2} sx={{ m: 1 }} direction={"column"}>
            <Stack spacing={2} sx={{ m: 1 }} direction={"row"}>
                <Paper sx={{ m: 1, px: 2 }}>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                        <Typography component="span" variant="body1" sx={{ fontWeight: 'bold', mr: 1 }}>
                            Remetente:
                        </Typography>
                        {sender?.display ?? props.selected.userId}
                    </Typography>

                    <Typography variant="body2" sx={{ mb: 1 }}>
                        <Typography component="span" variant="body1" sx={{ fontWeight: 'bold', mr: 1 }}>
                            Alvo:
                        </Typography>
                        {getObjectTargetName(props.selected.target)}: {target?.display ?? props.selected.targetId}
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography component="span" variant="body1" sx={{ fontWeight: 'bold' }}>
                            Prioridade:
                        </Typography>
                        <Chip
                            sx={{ 
                                width: "100px",  
                                color: (theme) => getMessagePriorityColor(theme, props.selected.messagePriority).contrastText,
                                border: (theme) => `1px solid ${getMessagePriorityColor(theme, props.selected.messagePriority).contrastText}`,
                                backgroundColor: (theme) => getMessagePriorityColor(theme, props.selected.messagePriority).main,
                            }}
                            label={getMessagePriorityName(props.selected.messagePriority)}
                            variant="filled"
                        />
                    </Typography>

                    <Typography variant="body2">
                        <Typography component="span" variant="body1" sx={{ fontWeight: 'bold', mr: 1 }}>
                            Enviada:
                        </Typography>
                        {datetimeSimplifier(props.selected.processed)}
                    </Typography>
                </Paper>
                <Box sx={{ m: 0, p: 2,
                    minWidth: "400px",
                    borderRadius: 3,
                    backgroundColor: (theme) => getMessagePriorityColor(theme, props.selected.messagePriority).main,
                    color: (theme) => getMessagePriorityColor(theme, props.selected.messagePriority).contrastText,
                    border: (theme) => `1px solid ${getMessagePriorityColor(theme, props.selected.messagePriority).contrastText}`,
                 }}>
                    <Typography variant="body2">
                        {pureMessage.selected?.text}
                    </Typography>
                </Box>

            </Stack>
            
            <TableContainer component={Paper} sx={{ m: 1 }}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" sx={{
                                    color: (theme) => theme.palette.primary.contrastText,
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                }}>Aluno</TableCell>
                            <TableCell align="left" sx={{
                                    color: (theme) => theme.palette.primary.contrastText,
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                }}>Usuário</TableCell>
                            <TableCell align="left" sx={{
                                    color: (theme) => theme.palette.primary.contrastText,
                                    backgroundColor: (theme) => theme.palette.primary.main,
                                }}>Lida</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {massiveMessageUser.list?.map((row) => (
                            <MassiveMessageDetailRow key={row.id} row={row} dismissedList={messageDismissed.list} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Stack>
    );

    return <PrizaContainer
        state={worstState([massiveMessageUser.state, messageDismissed.state, pureMessage.state])}
        toolbar={{
            label: "Detalhes da Mensagem Massiva",
            buttons: [
                {
                    label: "Fechar",
                    click: () => {
                        props.onClose();
                    }
                }
            ]
        }}
        messages={{
            empty: "Nenhuma mensagem massiva encontrada.",
            error: "Erro ao carregar mensagens massivas."
        }}
        content={content}
        retry={() => { 
            dispatch(messageDismissedSlice.actions.clean());
            dispatch(massiveMessageUserSlice.actions.clean());
            dispatch(pureMessageSlice.actions.clean());
        }}
    />;

};

export default MassiveMessageDetail;